import AppLogo from '@/assets/icons/app-logo.svg?react';
import SiemensLogo from '@/assets/icons/siemens.svg?react';
import { T } from '@/components/i18n/message.i18n.component';
import Button from '@/components/ui/button/button.component';

import { Footer } from '@/components/elements/footer/footer.component';
import { UnauthenticatedTemplate, useMsal } from '@azure/msal-react';
import { loginPageMessages } from './login.messages';

export const LoginPage = () => {
  const { instance } = useMsal();
  const handleRedirect = () => {
    instance.loginRedirect({
      scopes: [],
    });
  };

  return (
    <div className="bg-light-gray h-full w-full fixed flex flex-col items-center justify-center">
      <UnauthenticatedTemplate>
        <div className="bg-white w-[460px] shadow">
          <div className="flex flex-col p-6">
            <SiemensLogo className="h-[32px] w-[114px] fill-primary mb-4" />
            <div className="flex flex-row items-center mb-8">
              <AppLogo className="mr-1" />
              <h1>
                <T {...loginPageMessages.title} />
              </h1>
            </div>
            <Button variant="default" onClick={handleRedirect}>
              <T {...loginPageMessages.button} />
            </Button>
          </div>
          <div className="flex flex-row items-center">
            <div className="bg-other-stroke h-[2px] w-full" />
            <p className="px-5">
              <T {...loginPageMessages.or} />
            </p>
            <div className="bg-other-stroke h-[2px] w-full" />
          </div>
          <div className="flex flex-col p-6">
            <Button variant="secondary" onClick={handleRedirect}>
              <T {...loginPageMessages.requestAccess} />
            </Button>
          </div>
        </div>
      </UnauthenticatedTemplate>
      <Footer />
    </div>
  );
};
